export default __webpack_public_path__ + "static/media/slayder.1e325d1e.jpg";